export interface CurrencyOptions {
  currency?: string;
  locale?: string;
  /** Drop the decimal part for whole amounts (default true — menu prices are ₹249, not ₹249.00). */
  compact?: boolean;
}

/** Format a rupee amount as ₹1,234 (Indian digit grouping). */
export function formatCurrency(amount: number, opts: CurrencyOptions = {}): string {
  const { currency = 'INR', locale = 'en-IN', compact = true } = opts;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: compact && Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2
  }).format(amount);
}

/** Number with locale grouping, no currency symbol (e.g. loyalty points 1,240). */
export function formatNumber(value: number, locale = 'en-IN'): string {
  return new Intl.NumberFormat(locale).format(value);
}
